import React, { useMemo, useEffect, useRef, useState } from 'react';
import { StyledHeader, OfferLeaveConfirmTooltip } from './Header.styles';
import linkedinImg from '../../../assets/icon-linkedin-scraper.svg';
import messageImg from '../../../assets/icon-message-enrichment.svg';
import emailFinderImg from '../../../assets/icon-email-enrichment.svg';
import emailSendImg from '../../../assets/icon-email-sending.svg';
import iconNotification from '../../../assets/images/icon-notification.svg';
import coinsImg from '../../../assets/images/icon-coins.svg';
import iconPlay from '../../../assets/icon-play.png';
import iconStop from '../../../assets/icon-stop.png';
import ProfilePic from '../../../assets/uploadIcon.svg';
import coinImg from '../../../assets/icon-coin.svg';
import { IoClose } from 'react-icons/io5';
import Notifications from '../../molecules/Notifications';
import NavData from '../../../nav.json';
import { CgMenuLeft } from 'react-icons/cg';
import { IoMdSettings } from 'react-icons/io';
import { MdKeyboardArrowDown, MdOutlineEdit } from 'react-icons/md';
import { RiArrowDownSLine, RiArrowRightSLine } from 'react-icons/ri';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { calculatePercentage, formatStatus, getGreetingMessage, handleCreditsNames, formatLastActivity, formatDate, formatTime } from '../../../helpers/common';
import { AuthContext } from '../../../Context/authContext';
import { SubListLeadsContext } from '../../../Context/subListLeadsContext';
import { JobLeadsContext } from '../../../Context/jobLeadsContext';
import { useContextHook } from 'use-context-hook';
import Button from '../../molecules/Button';
import linkedinService from '../../../services/linkedinService';
import jobService from '../../../services/jobService';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import { CampaignAnalyticsContext } from '../../../Context/getCampaignName';
import { PendingApprovalsContext } from '../../../Context/pendingApprovalsContext';
import { GoArrowUp } from 'react-icons/go';
import { ConfirmBtn } from '../../automation/FlowBuilder.styles';
import { OFFER_FORM_DIRTY_CHECK } from '../CreateCompaign/useOfferForm';
import useClickOutside from '../../../hooks/useClickOutside';

const Header = () => {
  const [notifications, setNotifications] = useState(false);
  const [profileDrop, setProfileDrop] = useState(false);
  const [creditActive, setCreditActive] = useState(false);
  const NotificationRef = useRef(null);
  const ProfileDropRef = useRef(null);
  const CreditRef = useRef(null);
  const location = useLocation();
  const campaignId = location?.state?.campaign_id;
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [editingCampaignName, setEditingCampaignName] = useState('');
  const [campaignStatus, setCampaignStatus] = useState(location?.state?.status || 'running');
  const inputRef = useRef(null);
  const [quickActive, setQuickActive] = useState(false);
  const quickRef = useRef(null);
  const { id } = useParams();
  const [emailCreationUnderDomainData, setEmailCreationUnderDomainData] = useState(null);
  const [isEditingList, setIsEditingList] = useState(false);
  const [editingListName, setEditingListName] = useState('');
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [editingJobName, setEditingJobName] = useState('');
  const [lastActivity, setLastActivity] = useState(null);
  const [showOfferLeaveConfirm, setShowOfferLeaveConfirm] = useState(false);
  const crownEnabled = String(process.env.REACT_APP_CROW_ENABLED).toLowerCase() === 'true';
  const { user, hasPermission, permissions, getPermissions, refetch, allowedPages, fetchUser } = useContextHook(AuthContext, v => ({
    user: v.user,
    refetch: v.refetch,
    hasPermission: v.hasPermission,
    permissions: v.permissions,
    allowedPages: v.allowedPages,
    fetchUser: v.fetchUser,
    getPermissions: v.getPermissions,
  }));

  const isPendingApprovalsPage = location?.pathname === '/pending-approvals';
  const { pendingApprovalsTotalCount } = useContextHook(PendingApprovalsContext, v => ({
    pendingApprovalsTotalCount: v.totalCount,
  }));

  const canRenderCrow = crownEnabled && user?.data?.featureAccess?.agentAccess;
  // Get sublist name from context
  const { subListName } = useContextHook(SubListLeadsContext, v => ({
    subListName: v.subListName,
  }));


  const { jobName } = useContextHook(JobLeadsContext, v => ({
    jobName: v.jobName,
  }));
  const { campaignName: contextCampaignName } = useContextHook(CampaignAnalyticsContext, v => ({
    campaignName: v.campaignName,
  }));

  useEffect(() => {
    if (contextCampaignName && !editingCampaignName) {
      setEditingCampaignName(contextCampaignName);
    }
  }, [contextCampaignName]);

  useEffect(() => {
    if (subListName && !editingListName) {
      setEditingListName(subListName);
    }
  }, [subListName]);

  useEffect(() => {
    if (jobName && !editingJobName) {
      setEditingJobName(jobName);
    }
  }, [jobName]);


  useEffect(() => {
    if (location.pathname.startsWith('/lead-preview') && location.state?.lastActivity) {
      setLastActivity(location.state.lastActivity);
    }
  }, [location.pathname, location.state?.lastActivity]);



  // Listen for Quick Actions opening from other components to close Credits dropdown
  useEffect(() => {
    const handleQuickActionsOpen = () => {
      setCreditActive(false);
    };
    window.addEventListener('quick-actions-opened', handleQuickActionsOpen);
    return () => {
      window.removeEventListener('quick-actions-opened', handleQuickActionsOpen);
    };
  }, []);

  useEffect(() => {
    // keep local status in sync with router state updates
    if (location?.state?.status) {
      setCampaignStatus(location.state.status);
    }
  }, [location?.state?.status]);

  // Track emailCreationUnderDomain from sessionStorage
  useEffect(() => {
    const checkEmailCreationUnderDomain = () => {
      const stored = sessionStorage.getItem('emailCreationUnderDomain');
      setEmailCreationUnderDomainData(stored ? JSON.parse(stored) : null);
    };

    // Check on mount and when pathname changes
    checkEmailCreationUnderDomain();

    // Listen for storage events (when sessionStorage changes in other tabs/components)
    const handleStorageChange = e => {
      if (e.key === 'emailCreationUnderDomain') {
        checkEmailCreationUnderDomain();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check periodically for changes (since storage event doesn't fire in same tab)
    const interval = setInterval(checkEmailCreationUnderDomain, 100);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [location.pathname]);

  const handleTabClick = tab => {
    sessionStorage.setItem('emailAccountActiveTab', tab);
    navigate(location.pathname, { state: { activeTab: tab } });
  };
  const teamTabClick = tab => {
    navigate(location.pathname, { state: { activeTeamTab: tab } });
  };
  const profileTabClick = tab => {
    navigate(location.pathname, { state: { activeProfileTab: tab } });
  };

  const handleQuickAction = async () => {
    try {
      const payload = {
        list_id: Number(id),
      };
      const res = await linkedinService.emailEnrichment(payload);

      if (res.success) {
        Toast({ type: 'success', message: 'Email Enrichment Initiated' });
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    }
  };

  const pageName = NavData?.find(i => i?.route === location?.pathname);

  const handleClickOutsideNotification = event => {
    if (NotificationRef.current && !NotificationRef.current.contains(event.target)) {
      setNotifications(false);
    }
  };

  const handleClickOutsideCredit = event => {
    if (CreditRef.current && !CreditRef.current.contains(event.target)) {
      setCreditActive(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = e => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setIsEditing(false);
        setIsEditingList(false);
      }
    };

    document.addEventListener('click', handleClickOutsideNotification);
    document.addEventListener('click', handleClickOutsideCredit);
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutsideNotification);
      document.removeEventListener('click', handleClickOutsideCredit);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  function showAside() {
    document.body.classList.toggle('aside-active');
    if (document.body.classList.contains('aside-active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  const handlePauseCampaign = async () => {
    try {
      const res = await campaignService.pauseCampaign(campaignId);
      if (res.success) {
        setCampaignStatus('paused');
        Toast({ type: 'success', message: res.message });
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    }
  };

  const handleResumeCampaign = async () => {
    try {
      const res = await campaignService.resumeCampaign(campaignId);
      if (res.success) {
        setCampaignStatus('running');
        Toast({ type: 'success', message: res.message });
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    }
  };

  const handleRenameCampaign = async e => {
    try {
      // setLoading(true);
      const payload = {
        campaignId: campaignId,
        name: editingCampaignName,
      };
      const res = await campaignService.renameCampaign(payload);
      if (res?.success) {
        Toast({ type: 'success', message: res?.message });
        refetch();
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message });
    } finally {
      // setLoading(false);
    }
  };

  const handleRenameList = async () => {
    try {
      if (!editingListName?.trim()) {
        Toast({ type: 'error', message: 'Please enter a list name' });
        return;
      }
      const res = await linkedinService.updateListName({ id: id, name: editingListName });
      if (res?.success) {
        Toast({ type: 'success', message: 'List renamed successfully' });
        refetch();
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message || 'Failed to rename list' });
    }
  };

  const handleRenameJob = async () => {
    try {
      if (!editingJobName?.trim()) {
        Toast({ type: 'error', message: 'Please enter a job name' });
        return;
      }
      const res = await jobService.updateJobName({ id: id, name: editingJobName });
      if (res?.success) {
        Toast({ type: 'success', message: 'Job renamed successfully' });
        setIsEditingJob(false);
        refetch();
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message || 'Failed to rename job' });
    }
  };

  const dashboardPages = ['/get-started', '/dashboard'];
  const leadsModulePages = ['/leads-list', '/leads-hub'];
  const emailPages = ['/email-accounts', '/domains'];

  const storedEmailTab = sessionStorage.getItem('emailAccountActiveTab');
  const isOldUser = new Date(user?.data?.created_at) < new Date('2026-03-09');

  const defaultEmailTab = isOldUser ? 'domain' : 'single';

  let activeTab = location?.state?.activeTab || storedEmailTab || defaultEmailTab;

  if (!isOldUser && activeTab === 'domain') {
    activeTab = 'single';
  }
  const activeTeamTab = location?.state?.activeTeamTab || 'team';
  const activeProfileTab = location?.state?.activeProfileTab || 'profile-setting';

  const canInviteMembers = useMemo(() => hasPermission('workspace.add_member'), [permissions, hasPermission]);
  const canSeeInvoices = useMemo(() => hasPermission('invoices.view'), [permissions, hasPermission]);

  const openCrowCopilot = () => {
    if (window?.crow) {
      window.crow('open');
    }
  };

  const isCreateOfferPage = location.pathname === '/create-offer';
  const isUpdateOfferPage = /^\/offers\/[^/]+$/.test(location.pathname);

  const goBackToOffers = () => {
    navigate('/profile', { state: { activeProfileTab: 'offers' } });
  };

  useEffect(() => {
    setShowOfferLeaveConfirm(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!showOfferLeaveConfirm) return undefined;

    const handleClickOutside = event => {
      if (!event.target.closest('.offer-back-wrap')) {
        setShowOfferLeaveConfirm(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showOfferLeaveConfirm]);

  const handleOfferBackClick = () => {
    if (showOfferLeaveConfirm) return;

    if (isUpdateOfferPage) {
      const detail = { hasUnsavedChanges: false };
      window.dispatchEvent(new CustomEvent('offer-form-unsaved-check', { detail }));
      if (detail.hasUnsavedChanges) {
        setShowOfferLeaveConfirm(true);
        return;
      }
    }

    goBackToOffers();
  };

  const handleLeaveOfferWithoutSaving = () => {
    setShowOfferLeaveConfirm(false);
    goBackToOffers();
  };

  return (
    <StyledHeader>
      <div className="header-main-row">
        <div className="heading-box">
          {isCreateOfferPage || isUpdateOfferPage ? (
            <div className={`edit-name-header${showOfferLeaveConfirm ? ' offer-leave-confirm-open' : ''}`}>
              <div className="offer-back-wrap">
                <button type="button" className="btn-back" onClick={handleOfferBackClick}>
                  <MdKeyboardArrowLeft />
                </button>
                {showOfferLeaveConfirm && (
                  <OfferLeaveConfirmTooltip>
                    <p>You have unsaved changes. Leave without saving?</p>
                    <div className="confirm-actions">
                      <ConfirmBtn type="button" onClick={() => setShowOfferLeaveConfirm(false)}>
                        Cancel
                      </ConfirmBtn>
                      <ConfirmBtn type="button" $danger onClick={handleLeaveOfferWithoutSaving}>
                        Leave
                      </ConfirmBtn>
                    </div>
                  </OfferLeaveConfirmTooltip>
                )}
              </div>
              <strong className="launchpad">
                {isCreateOfferPage ? 'Create Offer' : 'Review & Update Your Offer'}
              </strong>
            </div>
          ) : location.pathname === '/create-campaign' && !location?.state?.isEdit ? (
            <strong className="launchpad">Launchpad 🚀</strong>
          ) : location.pathname === '/create-campaign' && location?.state?.isEdit ? (
            <>
              <div className="edit-name-header">
                <div className="campaign-name-holder">
                  <button className="btn-back" onClick={() => navigate(-1)}>
                    <MdKeyboardArrowLeft />
                  </button>
                  <div className="text-wrap" ref={inputRef}>
                    {isEditing ? (
                      <input
                        className="campaign-name-input"
                        type="text"
                        value={editingCampaignName}
                        autoFocus
                        onChange={e => setEditingCampaignName(e.target.value)}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRenameCampaign();
                            setIsEditing(false);
                          }
                        }}
                      />
                    ) : (
                      <>
                        <span className="campaign-name">{contextCampaignName || editingCampaignName}</span>
                        {campaignStatus !== 'completed' && (
                          <MdOutlineEdit
                            className="edit"
                            onClick={e => {
                              e.stopPropagation();
                              setEditingCampaignName(contextCampaignName || '');
                              setIsEditing(true);
                              setCreditActive(false);
                              window.dispatchEvent(new CustomEvent('close-quick-actions'));
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                  <span className="tag edit-tag">Campaign</span>
                </div>
                {(campaignStatus === 'running' || campaignStatus === 'paused') && (
                  <div className="btn-wrap">
                    {campaignStatus === 'paused' ? (
                      <button className="btn-resume" onClick={() => handleResumeCampaign()}>
                        <img src={iconPlay} alt="play" /> Running Campaign
                      </button>
                    ) : (
                      <button className="btn-stop" onClick={() => handlePauseCampaign()}>
                        <img src={iconStop} alt="stop" /> Pause Campaign
                      </button>
                    )}
                  </div>
                )}
              </div>
            </>
          ) : dashboardPages.includes(location.pathname) ? (
            <>
              {/* <button
              className={`btn ${location.pathname === '/get-started' ? 'active' : ''}`}
              onClick={() => navigate('/get-started')}>
              Get Started
            </button> */}
              <button
                className={`btn ${location.pathname === '/get-started' ? 'active' : ''}`}

                onClick={() => navigate('/get-started')}>
                <span id="get-started-btn">
                  Get Started
                </span>
              </button>
              <button
                className={`btn ${location.pathname === '/dashboard' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard')}>
                <span id="dashboard-btn">
                  Dashboard
                </span>
              </button>
            </>
          ) : leadsModulePages.includes(location.pathname) ? (
            <>
              <button
                className={`btn ${location.pathname === '/leads-list' ? 'active' : ''}`}
                onClick={() => navigate('/leads-list')}>
                <span id="leads-list-btn">
                  Leads List
                </span>
              </button>

              {process.env.REACT_APP_ENABLE_ADVANCE_SEARCH === 'true' && (
                <button
                  className={`btn ${location.pathname === '/leads-hub' ? 'active' : ''}`}
                  onClick={() => navigate('/leads-hub')}>
                  <span id="leads-hub-btn">
                    Leads Hub
                  </span>
                </button>)}
            </>
          ) : emailPages.includes(location.pathname) && emailCreationUnderDomainData ? (
            <>
              <div className="edit-name-header">
                <div className="campaign-name-holder">
                  <button
                    className="btn-back"
                    onClick={() => {
                      sessionStorage.removeItem('emailCreationUnderDomain');
                      navigate(location.pathname, { state: { activeTab: 'domain' }, replace: true });
                    }}>
                    <MdKeyboardArrowLeft />
                  </button>
                  <strong className="domain-name">{emailCreationUnderDomainData.domainName || 'Domain Emails'}</strong>
                  <span className="tag domain-tag">Domain</span>
                </div>
              </div>
            </>
          ) : emailPages.includes(location.pathname) ? (
            <div className="email-account-btns">
              {new Date(user?.data?.created_at) < new Date('2026-03-09') && (
                <button
                  className={`btn ${activeTab === 'domain' ? 'active' : ''}`}
                  onClick={() => handleTabClick('domain')}>
                  <span id="domains-btn">
                    Domains
                  </span>
                </button>
              )}
              <button
                className={`btn ${activeTab === 'single' ? 'active' : ''}`}
                onClick={() => handleTabClick('single')}>
                <span id="email-accounts-btn">
                  Email Accounts
                </span>
              </button>
            </div>
          ) : location.pathname === '/teams' ? (
            <div className="email-account-btns">
              <button className={`btn ${activeTeamTab === 'team' ? 'active' : ''}`} onClick={() => teamTabClick('team')}>
                Team
              </button>
              {canInviteMembers && (
                <button
                  className={`btn ${activeTeamTab === 'invitation' ? 'active' : ''}`}
                  onClick={() => teamTabClick('invitation')}>
                  <span id="invitations-btn">
                    Invitations
                  </span>
                </button>
              )}
            </div>
          ) : location.pathname === '/profile' ? (
            <div className="email-account-btns">
              <button
                className={`btn ${activeProfileTab === 'profile-setting' ? 'active' : ''}`}
                onClick={() => profileTabClick('profile-setting')}>
                Profile Setting
              </button>
              {canSeeInvoices && (
                <button
                  className={`btn ${activeProfileTab === 'invoice' ? 'active' : ''}`}
                  onClick={() => profileTabClick('invoice')}>
                  Invoice
                </button>
              )}
              {/* {user?.data?.featureAccess?.integrationAccess && ( */}
              <button
                className={`btn ${activeProfileTab === 'integrations' ? 'active' : ''}`}
                onClick={() => profileTabClick('integrations')}>
                Integrations
              </button>
              {/* )} */}
              <button
                className={`btn ${activeProfileTab === 'offers' ? 'active' : ''}`}
                onClick={() => profileTabClick('offers')}>
                Offers
              </button>
            </div>
          ) : location.pathname.startsWith('/single-list-lead') ? (
            <>

              <div className="edit-name-header">

                <div className="campaign-name-holder">
                  <button className="btn-back" onClick={() => navigate(-1)}>
                    <MdKeyboardArrowLeft />
                  </button>
                  <div className="text-wrap" ref={inputRef}>
                    {isEditingList ? (
                      <input
                        className="campaign-name-input"
                        type="text"
                        value={editingListName}
                        autoFocus
                        onChange={e => setEditingListName(e.target.value)}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRenameList();
                            setIsEditingList(false);
                          }
                        }}
                      />
                    ) : (
                      <>
                        <span className="campaign-name">{subListName || editingListName}</span>
                        <MdOutlineEdit
                          className="edit"
                          onClick={e => {
                            e.stopPropagation();
                            setEditingListName(subListName || '');
                            setIsEditingList(true);
                            setCreditActive(false);
                            window.dispatchEvent(new CustomEvent('close-quick-actions'));
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : location.pathname.startsWith('/single-job-lead') ? (
            <>
              <div className="edit-name-header">
                <div className="campaign-name-holder">
                  <button className="btn-back" onClick={() => navigate(-1)}>
                    <MdKeyboardArrowLeft />
                  </button>
                  <div className="text-wrap" ref={inputRef}>
                    {isEditingJob ? (
                      <input
                        className="campaign-name-input"
                        type="text"
                        value={editingJobName}
                        autoFocus
                        onChange={e => setEditingJobName(e.target.value)}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handleRenameJob();
                            setIsEditingJob(false);
                          }
                        }}
                      />
                    ) : (
                      <>
                        <span className="campaign-name">{jobName || editingJobName}</span>
                        <MdOutlineEdit
                          className="edit"
                          onClick={e => {
                            e.stopPropagation();
                            setEditingJobName(jobName || '');
                            setIsEditingJob(true);
                            setCreditActive(false);
                            window.dispatchEvent(new CustomEvent('close-quick-actions'));
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : location.pathname.startsWith('/lead-preview') ? (
            <>
              <div className="edit-name-header">
                <div className="campaign-name-holder">
                  <button className="btn-back" onClick={() => navigate(-1)}>
                    <MdKeyboardArrowLeft />
                  </button>
                  <strong className="lead-name">Lead Preview</strong>
                  <span className="tag">Lead</span>
                </div>
                <div className="info-active">
                  <span className="text"> Last Activity</span> | <span className="date"> {`${formatDate(lastActivity)} at ${formatTime(lastActivity)}`}</span>
                </div>
              </div>
            </>
          ) : location.pathname === '/campaign-launched' ? (
            <h1 className="page-title">Campaign Launched 🚀</h1>
          ) : location.pathname === '/create-task' ? (
            <h1 className="page-title">Create task</h1>
          ) : location.pathname === '/pending-approvals' ? (
            <h1 className="page-title">Pending Approvals&nbsp;<span className="pending-approvals-count">({pendingApprovalsTotalCount ?? 0})</span></h1>
          ) : (
            <h1 className="page-title">{pageName?.name}</h1>
          )}
        </div>

        <div className="header-right-col">
          {canRenderCrow &&
            <button type="button" className="copilot-btn" onClick={openCrowCopilot} variant="gradient" >
              Copilot
            </button>
          }

          {/* complete onboarding button if user didn't complete it and has no linkedin profile connected */}
          {user?.data?.status !== 'onboarding_completed' && !user?.data?.linkedinProfileExists && (
            <button
              type="button"
              className="complete-onboarding-btn"
              variant="gradient"
              onClick={() => navigate('/ai-onboarding')}>
              Complete Onboarding
            </button>
          )}

          <div className="notificationWraaper" ref={NotificationRef}>
            <div className="bell" onClick={() => setNotifications(prev => !prev)}>
              <img src={iconNotification} alt="bell" />
            </div>
            <div className={notifications ? 'notificationWrapper notificationWrapper-visible' : 'notificationWrapper'}>
              <Notifications notification_card={notifications} setNotifications={setNotifications} />
            </div>
          </div>

          <div className="hamburger" onClick={showAside}>
            <CgMenuLeft size={25} color="var(--primary)" />
          </div>
        </div>
      </div>
    </StyledHeader >
  );
};

export default Header;
